type UjianAvailability = {
  pekta: boolean;
  katam: boolean;
  pihtas: boolean;
};

type MaintenanceAttributes = {
  ujian_pekta?: unknown;
  ujian_katam?: unknown;
  ujian_pihtas?: unknown;
};

const DEFAULT_UJIAN: UjianAvailability = {
  pekta: false,
  katam: false,
  pihtas: false,
};

let ujianEnabled: UjianAvailability = { ...DEFAULT_UJIAN };

export const parseUjianFlag = (value: unknown): boolean => {
  if (value == null) return false;
  if (value === true || value === 1) return true;
  if (value === false || value === 0) return false;
  const normalized = String(value).trim().toLowerCase();
  return normalized === "yes" || normalized === "true";
};

export const setUjianSettings = (attributes: MaintenanceAttributes = {}) => {
  ujianEnabled = {
    pekta: parseUjianFlag(attributes.ujian_pekta),
    katam: parseUjianFlag(attributes.ujian_katam),
    pihtas: parseUjianFlag(attributes.ujian_pihtas),
  };
};

export const isUjianEnabledForAppType = (appType: string): boolean => {
  const key = String(appType).toLowerCase() as keyof UjianAvailability;
  return Boolean(ujianEnabled[key]);
};

export const resetUjianSettings = () => {
  ujianEnabled = { ...DEFAULT_UJIAN };
};
